import {
  Button,
  Container,
  Content,
  Frame,
  Footer,
  H2,
  Header,
  Stack,
  Text,
  Toolbar,
  ToolbarItem,
} from '@kinesis/bungle';
import { noop } from 'lodash/fp';
import { PendingInvitationList } from '@/components/pending-invitation-list';
import { InvitationData } from '@/types';

const PendingInvitationsBox = (props: PendingInvitationsBoxProps) => {
  const {
    onAccept,
    onDecline,
    onDone = noop,
    invitations,
    isLoading = false,
  } = props;
  // The intro sentence covers what the rows actually are: organisation
  // invitations, disclosure shares, or a mix of both.
  const hasOrganisation = invitations.some(
    (invitation) => invitation.namespace === 'organisation',
  );
  const hasDisclosure = invitations.some(
    (invitation) => invitation.namespace === 'disclosure',
  );
  const intro =
    hasOrganisation && hasDisclosure
      ? 'You have pending invitations on Kinesis.'
      : hasDisclosure
        ? invitations.length === 1
          ? 'You have a disclosure shared with you on Kinesis.'
          : 'You have disclosures shared with you on Kinesis.'
        : 'You have an invitation to join a new organisation on Kinesis.';
  // Sized for rows carrying an avatar, the label, the invited-by · kind
  // line and two buttons.
  return (
    <Content
      shadow
      background='white'
      borderRadiusSize='large'
      width={640}
      height={480}
    >
      <Container direction='vertical'>
        <Header border>
          <Content padding='medium' sizing='fill-container' paddingMode='equal'>
            <H2>Pending invitations</H2>
          </Content>
        </Header>
        <Frame>
          <Content
            background='white'
            sizing='fill-container'
            padding='large'
            paddingMode='equal'
            borderRadiusSize='large'
            borderRadiusPlacement='bottom'
            height='100%'
          >
            <Stack space='medium'>
              <Text>{intro}</Text>
              <PendingInvitationList
                onAccept={onAccept}
                onDecline={onDecline}
                invitations={invitations}
              />
            </Stack>
          </Content>
        </Frame>
        <Footer border>
          <Toolbar>
            <ToolbarItem>
              <Button
                variant='primary'
                magnitude='medium'
                onClick={onDone}
                loading={isLoading}
              >
                Done
              </Button>
            </ToolbarItem>
          </Toolbar>
        </Footer>
      </Container>
    </Content>
  );
};

export type PendingInvitationsBoxProps = {
  onAccept?: (token: string) => void;
  onDecline?: (token: string) => void;
  onDone?: () => void;
  invitations: InvitationData[];
  isLoading?: boolean;
};

export { PendingInvitationsBox };
